import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbea06f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "new-model",
  ref: "model"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-close" }, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require" }, "组织名称：", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上级组织：", -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require" }, "区划绑定：", -1))
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require" }, "名称：", -1))
const _hoisted_12 = { key: 4 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "备注：", -1))

import {
  reactive, withDefaults, ref, watch,
} from 'vue';

import {
  Modal, Button, Input, TreeSelect, message,Select,
} from 'ant-design-vue';
import { useStore, } from 'vuex';
import { postRequest, } from '@/request/request';
import areaPicker from '@/components/areaPicker/areaPicker.vue';

interface Props {
  createVisible?: boolean,
  type?: string,
  grandParent?: any,
  currentId?: any,
  companyName?: any,
}
interface FormState {
  roleName: string | undefined;
  note: string | undefined;
  organizationName: string | undefined;
  upperValue: string | undefined;
  regionId: string | undefined;
  regionLevel: number | undefined;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    createVisible: { type: Boolean, default: false },
    type: { default: '' },
    grandParent: { default: [] },
    currentId: { default: '' },
    companyName: null
  },
  emits: ['cancal', 'save',],
  setup(__props: any, { emit: emits }) {

const props = __props as { createVisible: boolean, type: string, grandParent: any, currentId: any, companyName?: any }


const store = useStore();
const { userInfo, } = store.state.login;
const { regionInfos, } = userInfo;
const {
  id,regionLevel, county,city,province,
} = regionInfos[0];

const nameTypes = {
  1: province,
  2: city,
  3: county,
};
const addItems = [{
  name: nameTypes[regionLevel] || '当前用户区域',
  regionLevel,
  id,
},];

/**
 * 查询当前id对应的对象
 * @method recursiveFind
 * @param {any[]} list 递归的数组
 * @returns {any} 递归查找
 */
const recursiveFind = (list: any[]): any => {
  let temp:any = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const item of list) {
    if (item.id === props.currentId) {
      return item;
    }
    if (item.children) {
      temp = recursiveFind(item.children);
    }
  }

  return temp;
};
const currentCompony = ref<any>();

const Form = reactive<FormState>({
  roleName: '',
  note: '',
  organizationName: '',
  upperValue: '',
  regionId: '',
  regionLevel,
});
const selectedLevel = ref<any>('');
const parentId = ref<any>('');

const handleSelect = (value: any, node: any, extra: any) => {
  selectedLevel.value = node.$attrs.level;
  parentId.value = node.$attrs.id;
  Form.upperValue = value;
};

watch(
  () => props.grandParent,
  (newValue) => {
    if (newValue.length) {
      currentCompony.value = recursiveFind(newValue);
      Form.upperValue = currentCompony.value?.value;
      selectedLevel.value = currentCompony.value?.level;
      parentId.value = currentCompony.value?.id;
    }
  },
  {
    deep: true,
  }
);


const handleCancle = ():void => {
  emits('cancal');
  Form.note = '';
  Form.organizationName = '';
  Form.roleName = '';
  Form.regionId = '';
  Form.regionLevel = regionLevel;
};

const handleSave = () => {
  if (Form.organizationName === '' && props.type === 'organization') {
    message.warn('请输入组织名称');

    return;
  }

  if (Form.regionId === '' && props.type === 'organization') {
    message.warn('请选择区划');

    return;
  }

  if (Form.roleName === '' && props.type === 'role') {
    message.warn('请输入角色名称');

    return;
  }

  emits('save', {
    selectedLevel: selectedLevel.value,
    parentCompany: parentId.value,
    ...Form,
  });

  Form.note = '';
  Form.organizationName = '';
  Form.roleName = '';
  Form.regionId = '';
  Form.regionLevel = regionLevel;
};

// 区域选择回调
const handleChange = (val: any) => {
  Form.regionLevel = val?.regionLevel;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Modal), {
      getContainer: () => _ctx.$refs.model,
      title: "新建",
      width: '4.2rem',
      height: '3rem',
      footer: false,
      visible: props.createVisible,
      onCancel: handleCancle
    }, {
      closeIcon: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (props.type === 'organization')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_unref(Input), {
                  style: {"width":"3rem"},
                  value: _unref(Form).organizationName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(Form).organizationName) = $event)),
                  placeholder: "请输入组织名称"
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          (props.type === 'organization')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_unref(TreeSelect), {
                  "show-search": "",
                  style: {"width":"100%"},
                  "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
                  "allow-clear": "",
                  "tree-default-expand-all": "",
                  placeholder: "请选择上级组织",
                  defaultValue: "最高级",
                  value: _unref(Form).upperValue,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(Form).upperValue) = $event)),
                  treeData: props.grandParent,
                  onSelect: handleSelect
                }, null, 8, ["value", "treeData"])
              ]))
            : _createCommentVNode("", true),
          (props.type === 'organization')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(areaPicker, {
                  regionId: _unref(Form).regionId,
                  "onUpdate:regionId": _cache[2] || (_cache[2] = ($event: any) => ((_unref(Form).regionId) = $event)),
                  region: _unref(id),
                  addItems: addItems,
                  onChange: handleChange
                }, null, 8, ["regionId", "region"])
              ]))
            : _createCommentVNode("", true),
          (props.type === 'role')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_unref(Input), {
                  class: "role",
                  style: {"width":"3.3rem"},
                  value: _unref(Form).roleName,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(Form).roleName) = $event)),
                  placeholder: "请输入角色名称"
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          (props.type === 'role')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_unref(Input), {
                  class: "role",
                  style: {"width":"3.3rem"},
                  value: _unref(Form).note,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(Form).note) = $event)),
                  placeholder: "请输入备注"
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", { class: "operation" }, [
          _createElementVNode("button", {
            class: "btn cancle",
            onClick: handleCancle
          }, "取消"),
          _createElementVNode("button", {
            class: "btn",
            onClick: handleSave
          }, "保存")
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "width", "visible"])
  ], 512))
}
}

})